import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import Typography from "@mui/material/Typography";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { ADMIN, COORDENADOR, PROFESSOR } from "../../Usuario/Perfil";
import { setIsAll, setSalas } from "./actions/actions";
import Container from "../../UI/Container";
import MensagemListAll from "./MensagemListAll";
import MensagemListUser from "./MensagemListUser";

export default function MensagemTable() {
  const user = useSelector((state) => state.usuario);
  const isAllState = useSelector((state) => state.isAllMensagemTable);
  const dispatch = useDispatch();

  const podeVerTodas = user?.perfil === ADMIN || user?.perfil === COORDENADOR;
  const podeCriarGrupo = podeVerTodas || user?.perfil === PROFESSOR;
  const isAll = podeVerTodas && Boolean(isAllState);

  const handleVisaoChange = (event, value) => {
    if (!value) return;
    const mostrarTodas = value === "todas";
    dispatch(setIsAll(mostrarTodas));
    if (!mostrarTodas) {
      dispatch(setSalas(null));
    }
  };

  return (
    <Container>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        spacing={2}
        mb={3}
      >
        <Box>
          <Typography variant="h6">Mensagens</Typography>
          <Typography variant="body2" color="text.secondary">
            {isAll ? "Todas as conversas da instituição." : "Suas conversas e grupos."}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          <Button
            variant="outlined"
            startIcon={<SearchIcon />}
            component={Link}
            to={isAll ? "/mensagem-find-all" : "/mensagem-find"}
            state={{ user }}
          >
            Procurar
          </Button>
          {podeCriarGrupo && (
            <Button
              variant="contained"
              startIcon={<GroupAddOutlinedIcon />}
              component={Link}
              to="/group-form"
            >
              Criar Grupo
            </Button>
          )}
        </Stack>
      </Stack>

      {podeVerTodas && (
        <ToggleButtonGroup
          size="small"
          exclusive
          value={isAll ? "todas" : "minhas"}
          onChange={handleVisaoChange}
          sx={{ mb: 2 }}
        >
          <ToggleButton value="minhas">Minhas Mensagens</ToggleButton>
          <ToggleButton value="todas">Todas as Mensagens</ToggleButton>
        </ToggleButtonGroup>
      )}

      {isAll ? <MensagemListAll /> : <MensagemListUser />}
    </Container>
  );
}
